<div id="main">

  <div class="modal-header">
    <h4 class="modal-title">{{projectName}} - {{"NEWSTEO_SUBSCRIPTION" | translate}}</h4>
    <button type="button" class="close" aria-label="Close" id="close" mat-dialog-close>
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body formModal">
    <app-progressbar *ngIf="showSpinner"></app-progressbar>
    <mat-horizontal-stepper [linear]="true" #stepper>
      <mat-step [stepControl]="newsteoSubscriptionForm">
        <form [formGroup]="newsteoSubscriptionForm">
          <ng-template matStepLabel>{{'INFORMATION' | translate}}</ng-template>

          <mat-form-field>
            <input matInput [placeholder]="('newsteoProjectId' | translate)" formControlName="newsteoProjectId">
          </mat-form-field>
          <p>{{"8_DAYS_RETRIEVING_SPECIAL_SUBSCRIPTION" | translate}}</p>

          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperNext [innerHTML]="'NEXT_BUTTON' | translate">
              Next
            </button>
          </div>
        </form>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>{{'CHECK_SAVE' | translate}}</ng-template>
        <div *ngIf="newsteoSubscriptionForm">
          <div><b [innerHtml]="'INFORMATION' | translate"></b></div>
          <mat-form-field>
            <input matInput [placeholder]="('newsteoProjectId' | translate)"
                   [value]="newsteoSubscriptionForm.value.newsteoProjectId"
                   [readonly]="true"
            >
          </mat-form-field>
          <br/>
          <div>
            <button class="btn btn-info" mat-button matStepperPrevious [innerHTML]="'BACK_BUTTON' | translate">
              Back
            </button>
            <button type="button" class="btn btn-warning" (click)="postNewsteoSubscription()">
              <app-progressbar *ngIf="showSpinner"></app-progressbar>
              {{'SAVE'|translate}}
            </button>
          </div>

        </div>
      </mat-step>
    </mat-horizontal-stepper>
  </div>
</div>
